import { lazy } from 'react';

const ECBARoutes = [
    {
        path: '/agent_us_referrals',
        component: lazy(() =>
            import('../../pages/Referrals/ECBA/NewReferrals'),
        ),
        meta: {
            action: 'read',
            resource: 'ecba-referrals',
        },
    },
    {
        path: '/agent_us_leads',
        component: lazy(() => import('../../pages/Referrals/ECBA/Leads')),
        meta: {
            action: 'read',
            resource: 'ecba-referrals',
        },
    },
    {
        path: '/agent_us_matters',
        component: lazy(() => import('../../pages/Referrals/ECBA/MattersList')),
        meta: {
            action: 'read',
            resource: 'ecba-referrals',
        },
    },
    {
        path: '/agent_us_matter/:matterId',
        component: lazy(() =>
            import('../../pages/Referrals/ECBA/MatterDetail'),
        ),
        meta: {
            action: 'read',
            resource: 'ecba-referrals',
        },
    },
    {
        path: '/lawyer_matters',
        component: lazy(() => import('../../pages/Referrals/ECBA/MattersList')),
        meta: {
            action: 'read',
            resource: 'us_lawyer_matters',
        },
    },
    {
        path: '/lawyer_matter/:matterId',
        component: lazy(() =>
            import('../../pages/Referrals/ECBA/MatterDetail'),
        ),
        meta: {
            action: 'read',
            resource: 'us_lawyer_matters',
            conditions: {},
        },
    },
    {
        path: '/create_us_referral',
        component: lazy(() =>
            import('../../pages/Referrals/ECBA/CreateECBAReferral'),
        ),
        meta: {
            action: 'create',
            resource: 'ecba-referrals',
        },
    },
    {
        path: '/agent_us_lawyers',
        component: lazy(() => import('../../pages/ECBA/LawyerList')),
        meta: {
            action: 'read',
            resource: 'ecba_lawyers',
        },
    },
    {
        path: '/view_us_lawyer/:lawyerId',
        component: lazy(() => import('../../pages/ECBA/LawyerDetail')),
        exact: true,
        meta: {
            navLink: '/ecba_lawyers',
            action: 'update',
            resource: 'ecba_lawyers',
        },
    },
    {
        path: '/agent_us_contacts',
        component: lazy(() => import('../../pages/ECBA/ContactsList')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_clients',
        },
    },
    {
        path: '/agent_contact/:contactId',
        component: lazy(() => import('../../pages/ECBA/ContactDetail')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_clients',
        },
    },
    {
        path: '/lawyer_leads',
        component: lazy(() => import('../../pages/Referrals/ECBA/LawyerLeads')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'us_lawyer_leads',
        },
    },
    {
        path: '/agent_appointments',
        component: lazy(() =>
            import('../../pages/Matters/Appointments/AgentAppointmentList'),
        ),
        meta: {
            action: 'read',
            resource: 'matter_agent_appointments',
        },
    },
];

export default ECBARoutes;
